import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormDiamond"><Path d="M22.9141 12L12 22.9141L1.08594 12L12 1.08594L22.9141 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormDiamond;
